import { useState } from "react";
import "./Toggle.scss";

export default function Toggle({ enabled=false, setEnabled }) {

  return (
    <div
      className={`toggle ${enabled ? "enabled" : ""}`}
      onClick={() => setEnabled(!enabled)}
    >
      <div className="circle" />
    </div>
  );
}
